import { List, Skeleton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

export default function AutocompleteSection({
  heading,
  loading,
  children,
  empty,
}) {
  return (
    <div>
      <Typography
        variant="overline"
        component="h3"
        sx={{ px: 2, pt: 1.5, pb: 0.5, color: 'text.secondary' }}>
        {heading}
      </Typography>
      {loading ? (
        <div style={{ padding: '0 16px 8px' }}>
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
        </div>
      ) : empty ? (
        <Typography
          variant="body2"
          sx={{ px: 2, pb: 1.5, color: 'text.secondary' }}>
          {empty}
        </Typography>
      ) : (
        <List dense disablePadding>
          {children}
        </List>
      )}
    </div>
  );
}

AutocompleteSection.propTypes = {
  heading: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  empty: PropTypes.string,
  children: PropTypes.node,
};
